import { DeleteStatus, UserStatus } from 'src/API';
import { useOrganization } from 'src/contexts/OrganizationContext';
import { useCallback, useMemo } from 'react';

export const useUser = () => {
  const { users, currentUser, isLoading } = useOrganization();
  const allUsers = useMemo(() => users, [users]);
  const activeUsers = useMemo(
    () =>
      users.filter(
        (user) =>
          user.status === UserStatus.ActivateComplete &&
          user.deleteStatus === DeleteStatus.notDeleted
      ),
    [users]
  );

  const getDepartmentUsers = useCallback(
    (departmentId: string) => users.filter((user) => user.department === departmentId),
    [users]
  );

  return {
    allUsers,
    activeUsers,
    getDepartmentUsers,
    currentUser,
    isLoading,
  };
};
